<template>
    <div class="root">
      <div class="content">
        <NavigationBar/>
        <h3 class="content_title">Electronics</h3>
        <ProductsGrid :products="getElectronicsData" v-if="getElectronicsData && !getIsElectronicsDataLoading"/>
        <div class="spinner-grow" role="status" v-else>
        </div>
        </div>
        <FooterView/>
    </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue';
import ProductsGrid from '../components/ProductsGrid.vue';
import FooterView from '../components/Footer.vue'
export default {
  name: 'ElectronicsScreen',
  components: {
    NavigationBar,
    ProductsGrid,
    FooterView
  },
  data(){
    return {
    itemsInCart:0,
    }
  },
  methods:{
    incrementCount(){
        this.$store.dispatch('increment')
    },
    decreaseCount(){
        this.itemsInCart--
    }
  },
  computed:{
    getElectronicsData(){
      return this.$store.state.electronicsProducts  
    },
    getIsElectronicsDataLoading(){
      return this.$store.state.isElectronicsProductsLoading
    }
  },
  async mounted() {
    this.$store.dispatch('getElectronics')
  }
  
}
</script>

<style scoped>
.content_title{
    margin: 25px;
}
.root{
  display: flex;
  flex-direction: column;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
  flex: 1; /* takes all available space */
}
</style>